import Vue from 'vue';
import VueI18n from 'vue-i18n';
import englishMessages from './locales/en';
import chineseMessages from './locales/zh-CN';
import { getStoredLanguage, persistLanguage } from './language';
import englishExtensions from './englishExtensions.generated';
import googleAuthTranslations from './googleAuthTranslations';
import loginUiTranslations from './loginUiTranslations';
import appUiTranslations from './appUiTranslations';
import chooseUiTranslations from './chooseUiTranslations';
import lotteryUiTranslations from './lotteryUiTranslations';
import extendedUiTranslations from './extendedUiTranslations';
import extendedUiSupplement from './extendedUiSupplement';
import repaymentRequestOverrides from './repaymentRequestOverrides';
import legacyUiTranslations from './legacyUiTranslations';
import recentOverrides from './recentOverrides';

Vue.use(VueI18n);

const mergeDeep = (target, source) => {
  Object.keys(source || {}).forEach(key => {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      target[key] = mergeDeep({ ...(target[key] || {}) }, source[key]);
    } else target[key] = source[key];
  });
  return target;
};

const english = mergeDeep({ ...englishMessages }, englishExtensions);
let chinese = mergeDeep({}, chineseMessages);
chinese = mergeDeep(chinese, recentOverrides['zh-CN'] || {});
chinese = mergeDeep(chinese, {
  googleAuth: googleAuthTranslations['zh-CN'],
  loginUi: loginUiTranslations['zh-CN'],
  appUi: appUiTranslations['zh-CN'],
  chooseUi: chooseUiTranslations['zh-CN'],
  lotteryUi: lotteryUiTranslations['zh-CN'],
  extendedUi: mergeDeep(
    mergeDeep({ ...(extendedUiTranslations['zh-CN'] || {}) }, extendedUiSupplement['zh-CN'] || {}),
    repaymentRequestOverrides['zh-CN'] || {}
  )
});
chinese = mergeDeep(chinese, legacyUiTranslations['zh-CN'] || {});

const initialLanguage = persistLanguage(getStoredLanguage());

export default new VueI18n({
  locale: initialLanguage,
  fallbackLocale: 'en',
  messages: { en: english, 'zh-CN': chinese },
  silentTranslationWarn: true
});
